export var AppearanceType;
(function (AppearanceType) {
    AppearanceType["Unknown"] = "Unknown";
    AppearanceType["Static"] = "Static";
    AppearanceType["Modal"] = "Modal";
    AppearanceType["Button"] = "Button";
    AppearanceType["Slider"] = "Slider";
    AppearanceType["Comparer"] = "Comparer"; // HYPONLINE-91
})(AppearanceType || (AppearanceType = {}));
